export const inIFrame = () => window.top !== window.self;
